<!-- DatePicker template wrapped in HxFormGroup for error display -->
<hx-form-group [error]="_showErrors()">
  <div
    class="hx-date-picker"
    [class.hx-date-picker--disabled]="disabled()"
    [class.hx-date-picker--range]="mode() === 'range'"
    [class.hx-date-picker--required-empty]="isRequiredAndEmpty()"
    [class.hx-date-picker--with-label]="showLabel()"
    [class.hx-date-picker--label-horizontal]="showLabel() && labelAlignment() === 'horizontal'"
    [class.hx-date-picker--label-vertical]="showLabel() && labelAlignment() === 'vertical'">
    <!-- Inline Label (conditionally shown) -->
    @if (showLabel()) {
      <hx-label
        class="hx-date-picker__label"
        [description]="labelText()"
        [required]="required()"
        fontWeight="Medium"
        [tooltip]="tooltip()"
        [tooltipPosition]="tooltipPosition()"
        [tooltipColor]="tooltipColor()"></hx-label>
    }

    <!-- Single input field for both single and range modes -->
    <div class="hx-date-picker__single-input-wrapper" (focusout)="onFocusOut($event)">
      <hx-input
        #dateInput
        class="hx-date-picker__input-field"
        [class.hx-input-invalid]="isRequiredAndEmpty()"
        type="text"
        [id]="id()"
        [attr.name]="id()"
        [placeholder]="placeholderText()"
        [attr.aria-expanded]="isOpen()"
        [attr.aria-haspopup]="'dialog'"
        [attr.aria-readonly]="readonly()"
        [attr.aria-label]="ariaLabelText()"
        [disabled]="disabled()"
        [readonly]="readonly()"
        [value]="displayValue()"
        (click)="toggleCalendar()"
        (focusChange)="onInputFocusChange($event)"
        (valueChange)="onInputValueChange($event)" />
      <button
        class="hx-date-picker__calendar-icon-button"
        tabindex="-1"
        type="button"
        title="Open calendar"
        [attr.aria-label]="'Open calendar'"
        [disabled]="disabled()"
        [attr.aria-readonly]="readonly()"
        (click)="toggleCalendar()">
        <hx-icon svgIcon="calendar" />
      </button>
    </div>
  </div>

  <!-- Error Messages -->
  @if (_showErrors()) {
    <span hx-error>
      @if (validationErrors()?.['matDatepickerParse']) {
        {{ _getErrorMessage('matDatepickerParse') }}
      } @else if (validationErrors()?.['required']) {
        {{ _getErrorMessage('required') }}
      } @else if (validationErrors()?.['matDatepickerMin']) {
        {{ _getErrorMessage('matDatepickerMin') }}
      } @else if (validationErrors()?.['matDatepickerMax']) {
        {{ _getErrorMessage('matDatepickerMax') }}
      } @else if (validationErrors()?.['matDatepickerFilter']) {
        {{ _getErrorMessage('matDatepickerFilter') }}
      } @else if (validationErrors()?.['dateRangeInvalid']) {
        {{ _getErrorMessage('dateRangeInvalid') }}
      }
    </span>
  }
</hx-form-group>
